import { render, staticRenderFns } from "./Rocada.vue?vue&type=template&id=5380f6a2&"
import script from "./Rocada.vue?vue&type=script&lang=js&"
export * from "./Rocada.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports